(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[41959],{

/***/ 12459:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
}), 'CloudUpload');

exports.Z = _default;

/***/ }),

/***/ 64566:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

exports.Z = _default;

/***/ }),

/***/ 43099:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
}), 'GetApp');

exports.Z = _default;

/***/ }),

/***/ 37315:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}), 'PlayCircleOutline');

exports.Z = _default;

/***/ }),

/***/ 428:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
}), 'Replay');

exports.Z = _default;

/***/ }),

/***/ 58365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59693);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40922);






var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      // Create a "on paper" color with sufficient contrast retaining the color
      backgroundColor: (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__/* .fade */ .U1)(theme.palette.text.primary, theme.palette.type === 'light' ? 0.11 : 0.13),
      height: '1.2em'
    },

    /* Styles applied to the root element if `variant="text"`. */
    text: {
      marginTop: 0,
      marginBottom: 0,
      height: 'auto',
      transformOrigin: '0 60%',
      transform: 'scale(1, 0.60)',
      borderRadius: theme.shape.borderRadius,
      '&:empty:before': {
        content: '"\\00a0"'
      }
    },

    /* Styles applied to the root element if `variant="rect"`. */
    rect: {},

    /* Styles applied to the root element if `variant="circle"`. */
    circle: {
      borderRadius: '50%'
    },

    /* Styles applied to the root element if `animation="pulse"`. */
    pulse: {
      animation: '$pulse 1.5s ease-in-out 0.5s infinite'
    },
    '@keyframes pulse': {
      '0%': {
        opacity: 1
      },
      '50%': {
        opacity: 0.4
      },
      '100%': {
        opacity: 1
      }
    },

    /* Styles applied to the root element if `animation="wave"`. */
    wave: {
      position: 'relative',
      overflow: 'hidden',
      '&::after': {
        animation: '$wave 1.6s linear 0.5s infinite',
        background: "linear-gradient(90deg, transparent, ".concat(theme.palette.action.hover, ", transparent)"),
        content: '""',
        position: 'absolute',
        transform: 'translateX(-100%)',
        // Avoid flash during server-side hydration
        bottom: 0,
        left: 0,
        right: 0,
        top: 0
      }
    },
    '@keyframes wave': {
      '0%': {
        transform: 'translateX(-100%)'
      },
      '60%': {
        // +0.5s of delay between each loop
        transform: 'translateX(100%)'
      },
      '100%': {
        transform: 'translateX(100%)'
      }
    },

    /* Styles applied when the component is passed children. */
    withChildren: {
      '& > *': {
        visibility: 'hidden'
      }
    },

    /* Styles applied when the component is passed children and no width. */
    fitContent: {
      maxWidth: 'fit-content'
    },

    /* Styles applied when the component is passed children and no height. */
    heightAuto: {
      height: 'auto'
    }
  };
};
var Skeleton = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Skeleton(props, ref) {
  var _props$animation = props.animation,
      animation = _props$animation === void 0 ? 'pulse' : _props$animation,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'span' : _props$component,
      height = props.height,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      width = props.width,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["animation", "classes", "className", "component", "height", "variant", "width"]);

  var hasChildren = Boolean(other.children);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    ref: ref,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, classes[variant], className, hasChildren && [classes.withChildren, !width && classes.fitContent, !height && classes.heightAuto], animation !== false && classes[animation])
  }, other, {
    style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      width: width,
      height: height
    }, other.style)
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiSkeleton'
})(Skeleton));

/***/ }),

/***/ 45964:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/market/[id]",
      function () {
        return __webpack_require__(76429);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 44907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79794);




var GetAppData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(appId) {
        var data, colPublicGcf, colPrivateGcf, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = "";
                    if (!appId) return [
                        2,
                        ""
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    return [
                        4,
                        components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_0__/* .projectFirestore.collection */ .H.collection("market").doc("public").collection("app").where("appId", "==", appId).get()
                    ];
                case 2:
                    colPublicGcf = _state.sent();
                    if (!(colPublicGcf.docs.length > 0)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        colPublicGcf.forEach(function(doc) {
                            data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, doc.data());
                        })
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        7
                    ];
                case 4:
                    return [
                        4,
                        components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_0__/* .projectFirestore.collection */ .H.collection("market").doc("private").collection("app").where("appId", "==", appId).get()
                    ];
                case 5:
                    colPrivateGcf = _state.sent();
                    if (!(colPrivateGcf.docs.length > 0)) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        colPrivateGcf.forEach(function(doc) {
                            data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, doc.data());
                        })
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        2,
                        data
                    ];
                case 8:
                    error = _state.sent();
                    return [
                        3,
                        9
                    ];
                case 9:
                    return [
                        2
                    ];
            }
        });
    });
    return function GetAppData(appId) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (GetAppData);


/***/ }),

/***/ 68590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



var SEO = function(param) {
    var url = param.url, title = param.title, desc = param.desc;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title ? title : "인공지능 서비스 마켓 아이소"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: desc ? desc : "AISO는 웹 기반의 다양한 AI 서비스를 쉽게 제작 판매하고 이용할 수 있는 인공지능플랫폼입니다."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: "aiso, 인공지능, 인공지능 서비스, AI, machine learning"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url ? url : "https://aiso.ai"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title ? title : "인공지능 서비스 마켓 아이소"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: desc ? desc : "AISO는 웹 기반의 다양한 AI 서비스를 쉽게 제작 판매하고 이용할 수 있는 인공지능플랫폼입니다."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "https://aiso.ai/images/header/aiso_logo.png"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 76429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./pages/user/market/appDetailMenu/appDetailComments.js
var appDetailComments = __webpack_require__(81744);
// EXTERNAL MODULE: ./pages/user/market/appDetailMenu/appHeader.js + 3 modules
var appHeader = __webpack_require__(21520);
// EXTERNAL MODULE: ./pages/user/market/appDetailMenu/appTitle.js
var appTitle = __webpack_require__(2839);
// EXTERNAL MODULE: ./pages/user/market/appDetailMenu/appPreview.js + 1 modules
var appPreview = __webpack_require__(45875);
// EXTERNAL MODULE: ./pages/user/market/appDetailMenu/appContent.js
var appContent = __webpack_require__(40366);
// EXTERNAL MODULE: ./pages/user/market/appDetailMenu/appRun/Basic.js + 1 modules
var Basic = __webpack_require__(53489);
// EXTERNAL MODULE: ./pages/user/market/appDetailMenu/appRun/Custom.js + 1 modules
var Custom = __webpack_require__(4092);
// EXTERNAL MODULE: ./pages/user/market/appDetailMenu/appLicense.js
var appLicense = __webpack_require__(31266);
// EXTERNAL MODULE: ./node_modules/firebase/app/dist/index.esm.js
var index_esm = __webpack_require__(15503);
// EXTERNAL MODULE: ./components/SEO.js
var SEO = __webpack_require__(68590);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(58365);
;// CONCATENATED MODULE: ./components/skeleton/SkeletonMarketDetail.js




var SkeletonMarketDetail = function(param) {
    var headUrl = param.headUrl, headTitle = param.headTitle, headDesc = param.headDesc;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                url: headUrl,
                title: headTitle,
                desc: headDesc
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "page-content w-full pt-12 pb-36",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "aiso-card shadow-md",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "sm:flex justify-between items-start border-b border-ddd p-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex justify-start items-start",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                    animation: "wave",
                                                    variant: "circle",
                                                    width: 40,
                                                    height: 40
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "pl-3 mt-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                            animation: "wave",
                                                            height: 20,
                                                            width: 80
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                            animation: "wave",
                                                            height: 20,
                                                            width: 100
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex justify-end pt-2 sm:pt-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mr-3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        animation: "wave",
                                                        variant: "rect",
                                                        height: 20,
                                                        width: 20
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mr-3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        animation: "wave",
                                                        variant: "rect",
                                                        height: 20,
                                                        width: 20
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        animation: "wave",
                                                        variant: "rect",
                                                        height: 20,
                                                        width: 20
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full px-6 lg:px-32 py-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pt-2 pb-4 sm:flex justify-between items-start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-lg font-bold text-333 font-gmarket-medium break-all sm:pr-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                animation: "wave",
                                                height: 20,
                                                width: 100
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-xs text-333 font-gmarket-medium font-bold min-w-max flex justify-end items-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                animation: "wave",
                                                height: 20,
                                                width: 100
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full px-6 lg:px-32 py-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "aiso-card-img pb-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                    animation: "wave",
                                                    variant: "rect",
                                                    height: 200,
                                                    width: "100%"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                    animation: "wave",
                                                    variant: "rect",
                                                    height: 200,
                                                    width: "100%"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-full md:flex mt-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-full md:w-1/2 h-1/2 mr-1",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        animation: "wave",
                                                        variant: "rect",
                                                        height: 30,
                                                        width: "100%"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-full md:w-1/2 h-1/2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        animation: "wave",
                                                        variant: "rect",
                                                        height: 30,
                                                        width: "100%"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full px-6 lg:px-32 pt-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    animation: "wave",
                                    variant: "rect",
                                    height: 30,
                                    width: "100%"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full px-6 lg:px-32 pt-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    animation: "wave",
                                    variant: "rect",
                                    height: 30,
                                    width: "100%"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full px-6 lg:px-32 py-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full mt-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full flex flex-col center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-full mt-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "row relative",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-full flex flex-col center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                                            className: "w-full mx-3 mb-3 sm:w-4/6",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "w-full",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                        animation: "wave",
                                                                        height: 40,
                                                                        width: "100%"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                        animation: "wave",
                                                                        height: 40,
                                                                        width: "100%"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-full flex flex-col items-center justify-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-full flex items-center justify-center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                            animation: "wave",
                                                            variant: "rect",
                                                            height: 50,
                                                            width: "100%"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var skeleton_SkeletonMarketDetail = (SkeletonMarketDetail);

// EXTERNAL MODULE: ./components/GetAppData.js
var GetAppData = __webpack_require__(44907);
;// CONCATENATED MODULE: ./pages/user/market/[id].js
/** @format */ 




// import useSettings from "stores/settings";
// import { observer } from "mobx-react-lite";

// Detail Menu

// import AppDetailInquiry from "./appDetailMenu/inquiry";

// import AppHashTag from "./appDetailMenu/appHashTag";






// import AppBodyDataAnalysis from "./appDetailMenu/appBodyDataAnalysis";



// import AdExample from "components/adsense/AdExample";

var AppDetailPage = function(param) {
    var headUrl = param.headUrl, headTitle = param.headTitle, headDesc = param.headDesc;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(true), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(null), data = ref1[0], setData = ref1[1];
    /**
   * 데이터 받아오기
   * 1. 앱 정보 받아오기
   * 2. 개발자 정보 받아오기
   */ (0,react.useEffect)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var _query, appId, getData;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _query = router.query, appId = _query.id;
                    if (!appId) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,GetAppData/* default */.Z)(router.query.id)
                    ];
                case 1:
                    getData = _state.sent();
                    if (getData) {
                        setData(getData);
                        setLoading(false);
                    }
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        router
    ]);
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_SkeletonMarketDetail, {
        headUrl: headUrl,
        headTitle: headTitle,
        headDesc: headDesc
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                url: headUrl,
                title: headTitle,
                desc: headDesc
            }),
            !data || data === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center items-center my-4"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "page-content w-full pt-20 pb-20",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "aiso_detail_wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(appHeader["default"], (0,_object_spread/* default */.Z)({}, data)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(appTitle["default"], {
                                appName: data.appName,
                                price: data.price
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(appPreview["default"], (0,_object_spread/* default */.Z)({}, data)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(appContent["default"], {
                                content: data.content
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(appLicense["default"], (0,_object_spread/* default */.Z)({}, data)),
                            data.type === "custom" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Custom["default"], (0,_object_spread/* default */.Z)({}, data)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic["default"], (0,_object_spread/* default */.Z)({}, data)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(appDetailComments["default"], (0,_object_spread/* default */.Z)({}, data))
                        ]
                    })
                })
            })
        ]
    });
};
AppDetailPage.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var asPath, query, id, headTitle, headDesc, headUrl, publicDocRef, privateDocRef, publicValue, privateValue, error, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    asPath = param.asPath, query = param.query;
                    id = query.id;
                    headTitle = "아이소";
                    headDesc = "인공지능 마켓, 아이소 입니다.";
                    headUrl = "https://aiso.ai".concat(asPath);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    publicDocRef = index_esm/* default.firestore */.Z.firestore().collection("market").doc("public").collection("app").doc(id);
                    privateDocRef = index_esm/* default.firestore */.Z.firestore().collection("market").doc("private").collection("app").doc(id);
                    return [
                        4,
                        publicDocRef.get()
                    ];
                case 2:
                    publicValue = _state.sent();
                    if (!publicValue.exists) return [
                        3,
                        3
                    ];
                    headTitle = publicValue.data().appName;
                    headDesc = publicValue.data().oneLineContent;
                    return [
                        3,
                        5
                    ];
                case 3:
                    return [
                        4,
                        privateDocRef.get()
                    ];
                case 4:
                    privateValue = _state.sent();
                    if (privateValue.exists) {
                        headTitle = privateValue.data().appName;
                        headDesc = privateValue.data().oneLineContent;
                    }
                    _state.label = 5;
                case 5:
                    return [
                        3,
                        7
                    ];
                case 6:
                    error = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 7:
                    _tmp = {};
                    return [
                        2,
                        (_tmp.headUrl = headUrl, _tmp.headTitle = headTitle, _tmp.headDesc = headDesc, _tmp)
                    ];
            }
        });
    });
    return function(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var _id_ = (AppDetailPage);


/***/ }),

/***/ 40366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core_Accordion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9607);
/* harmony import */ var _material_ui_core_AccordionSummary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50743);
/* harmony import */ var _material_ui_core_AccordionDetails__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61201);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64566);








var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            width: "100%",
            boxShadow: "none",
            backgroundColor: " rgba(255, 255, 255, 0.4) !important",
            borderBottom: "3px solid rgba(255, 255, 255, 0.5) !important"
        },
        padding: {
            paddingTop: "7px",
            paddingBottom: "7px"
        },
        heading: {
            fontSize: theme.typography.pxToRem(16),
            fontWeight: "bold",
            color: "#000"
        },
        contentBg: {
            backgroundColor: " rgba(255, 255, 255, 0.6) !important",
            paddingTop: "30px"
        }
    };
});
var AppContent = function(param) {
    var content = param.content;
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full px-6 lg:px-32 pt-3",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: classes.root,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_AccordionSummary__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    expandIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
                    className: classes.padding,
                    "aria-controls": "panel1a-content",
                    id: "panel1a-header",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: classes.heading,
                        children: "설명 상세보기"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_AccordionDetails__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: classes.contentBg,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: content
                        }
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AppContent);


/***/ }),

/***/ 31266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core_Accordion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9607);
/* harmony import */ var _material_ui_core_AccordionSummary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50743);
/* harmony import */ var _material_ui_core_AccordionDetails__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61201);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64566);








var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            width: "100%",
            boxShadow: "none",
            backgroundColor: " rgba(255, 255, 255, 0.4) !important",
            borderBottom: "3px solid rgba(255, 255, 255, 0.5) !important"
        },
        padding: {
            paddingTop: "7px",
            paddingBottom: "7px"
        },
        heading: {
            fontSize: theme.typography.pxToRem(16),
            fontWeight: "bold",
            color: "#000"
        },
        contentBg: {
            backgroundColor: " rgba(255, 255, 255, 0.6) !important",
            paddingTop: "30px"
        }
    };
});
var AppContent = function(param) {
    var license = param.license;
    var classes = useStyles();
    if (license) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "w-full px-6 lg:px-32 pt-1 pb-5",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: classes.root,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_AccordionSummary__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        expandIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
                        className: classes.padding,
                        "aria-controls": "panel1a-content",
                        id: "panel1a-header",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            className: classes.heading,
                            children: "LICENSE"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_AccordionDetails__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: classes.contentBg,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: license
                            },
                            className: "text-xs break-all"
                        })
                    })
                ]
            })
        });
    } else {
        return "";
    }
};
/* harmony default export */ __webpack_exports__["default"] = (AppContent);


/***/ }),

/***/ 2839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var AppTitle = function(param) {
    var appName = param.appName, price = param.price;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full px-6 lg:px-32 pt-10 pb-4",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "sm:flex justify-between items-start",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-xl font-bold text-black break-all sm:pr-5",
                    children: appName
                }),
                Number(price) === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-lg text-black font-gmarket-medium font-bold min-w-max flex justify-end items-center",
                    children: "Free"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "text-base text-black font-gmarket-medium font-bold min-w-max flex justify-end items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "font-bold text-lg text-black mr-1",
                            children: price
                        }),
                        " Credit"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AppTitle);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [34619,52387,94924,33426,76328,85388,868,22004,39054,32512,19843,94637,67872,99573,45875,46383,4092,53489,81744,21520,49774,92888,40179], function() { return __webpack_exec__(45964); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);